



















































































import { Component, Mixins, Ref } from 'vue-property-decorator';
import ProductListMethodsMixin from '@/components/product/ProductListMethodsMixin';
import ProductContent from '@/components/product/ProductListContent.vue';
import ProductListCateCascade from '@/components/product/ProductListCateCascade.vue';
import ProductsSummary from '@/components/product/ProductListSummary.vue';
import ProductSearchMenu from '@/components/product/ProductListSearchMenu.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import PageFormBtn from '@/components/board/common/PageFormBtn.vue';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import PageDateRangePicker from '@/components/board/common/PageDateRangePicker.vue';
import ProductListCheckBox from '@/components/product/ProductPopSearchCheckbox.vue';
import PageDateFilterBtns from '@/components/board/common/PageDateFilterBtns.vue';
import CustomCheckbox from '@/components/product/ProductListCustomCheckbox.vue';
import PageContentBottom from '@/components/board/common/PageBottomContent.vue';
import ProductListSlotLeft from '@/components/product/ProductListSlotLeft.vue';
import ProductListSlotRight from '@/components/product/ProductListSlotRight.vue';
import ProductListStockSync from '@/components/product/ProductListStockSync.vue';
import PageSizeData from '@/components/board/mixins/PageSizeData';
import {toI18n} from '@/utils/commonUtils';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';

const duplicateCommaReplacer = string => string.replace(/[*,*]{2,}/g, ',');

@Component({
  components: {
	  ExcelCreateButton,
    ProductContent,
    PageTitle,
    PageFormBtn,
    ProductsSummary,
    ProductSearchMenu,
    PageFormSelect,
    PageDateRangePicker,
    ProductListCheckBox,
    PageDateFilterBtns,
    ProductListCateCascade,
    CustomCheckbox,
    PageContentBottom,
    ProductListSlotLeft,
    ProductListSlotRight,
    PageSizeData,
    ProductListStockSync
  }
})
export default class ProductsList extends Mixins(ProductListMethodsMixin, PageSizeData) {
  @Ref('inputRef')
  readonly inputRef: HTMLInputElement;

  private get keywordPlaceHolder (): string {
    if (this.searchParams['keywordInfo.type'] === 'GROUP_MANAGEMENT_CODE') {
      return this.pLI18n('PLD_GROUP_MANAGEMENT_CODE_PLACEHOLDER');
    }

    return this.pLI18n('YOU_CAN_SEARCH_FOR_MULTIPLE_PRODUCTS');
  }

  public pLI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_PRODUCTLIST_' + needToI18nStr));
  }

  private convertToKeywordList(value: string): string[] {
    const keywordsWithSpacesRemoved = value.replace(/\r\n|\n|\r/g, ',').replace(/\s/g, '');
    return duplicateCommaReplacer(keywordsWithSpacesRemoved).split(',');
  }

  private validateKeywordLength(): void {
    this.inputRef.value = this.checkValueLength(this.inputRef.value);

    this.$emit('input', this.inputRef.value);
    this.searchParams['keywordInfo.keywords'] = this.inputRef.value;
  }

  private checkValueLength(value: string): string {
    const MAX_WORD_LENGTH = 100;
    const MAX_CHAR_LENGTH = 1000;
    const inputKeyword = duplicateCommaReplacer(value);
    const keywords = this.convertToKeywordList(inputKeyword);

    let strKeyword = keywords.join(',');
    if (strKeyword.startsWith(',')) {
      strKeyword = strKeyword.substring(1);
      keywords.shift();
    }
    this.searchParams['keywordInfo.keywords'] = strKeyword;

    if (keywords.length > MAX_WORD_LENGTH) {
      alert(this.$t('PRODUCT_PRODUCT_MAX_KEYWORD', [MAX_WORD_LENGTH]));
      return inputKeyword.substring(0, value.length - 1);
    }

    if (inputKeyword.length > MAX_CHAR_LENGTH) {
      alert(this.$t('PRODUCT_PRODUCT_MAX_CHAR', [MAX_CHAR_LENGTH]));
      return inputKeyword.substring(0, value.length - 1);
    }

    return inputKeyword;
  }
}
